import { useCallback } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { AdminFormRow } from '@ui';
import { Checkbox } from '@ds';
import { OpoRoleEnum } from '@/api/apis/customer';
import { OPO_CONTACT_ROLE_NAMES } from '@/constants/customer.constants';
import { CreateOpoContactFormValues } from './config';

export const CreateOpoContactRolesField = () => {
  const { control, setValue, getValues } = useFormContext<CreateOpoContactFormValues>();

  const parentId = useWatch({
    control,
    name: 'parentId',
  });

  const handleRoleChange = useCallback(
    (role: OpoRoleEnum, isSelected: boolean) => {
      const selectedRoles = getValues('memberships.0.roles') ?? [];

      const nextRoles = isSelected
        ? [...selectedRoles, role]
        : selectedRoles.filter((selectedRole) => selectedRole !== role);

      setValue(
        'memberships',
        [
          {
            opoOrganizationId: parentId,
            roles: nextRoles,
          },
        ],
        {
          shouldDirty: true,
          shouldValidate: true,
        },
      );
    },
    [getValues, parentId, setValue],
  );

  return (
    <AdminFormRow title="Role" inputWrapperClass="max-w-240" isRequired>
      <Controller
        name="memberships.0.roles"
        control={control}
        render={({ field, fieldState: { error } }) => {
          const selectedRoles = field.value ?? [];

          return (
            <>
              <div className="flex flex-wrap gap-4">
                {Object.values(OpoRoleEnum).map((role) => (
                  <Checkbox
                    key={role}
                    size="md"
                    value={role}
                    className="p-0 m-2"
                    isSelected={selectedRoles.includes(role)}
                    onValueChange={(isSelected) => handleRoleChange(role, isSelected)}
                  >
                    {OPO_CONTACT_ROLE_NAMES[role]}
                  </Checkbox>
                ))}
              </div>

              {error?.message && <div className="text-danger-40 text-s-r mt-1 ml-1">{error.message}</div>}
            </>
          );
        }}
      />
    </AdminFormRow>
  );
};
